<template>
    <span>
        <template v-for="(e, idx) in textParts">
            <span     :key="idx">{{ e }}</span>
        </template>
    </span>
</template>

<script>
import { mapState }         from 'vuex'

export default {
    name: "TrDisplay",
    props: {
        val:    { type: [String, Array], required: true},
        t9n:    { type: Boolean, default: false},
    },
    computed : {
        ...mapState ("translation", {
            tids:        state => state.tid,
            targetLang:  state => state.targetLang,
            sourceLang:  state => state.sourceLang,
            languages:   state => state.languages,
        }),
        textParts () {
            if (this.t9n) {
                let result = this.val.map ((e) => {
                    let p = e
                    if (typeof e !== "string") {
                        const tid = e [0]
                        const trLangs = this.languages [this.targetLang] [1]
                        if (trLangs !== undefined) {
                            p = trLangs [tid]
                        }
                        if (p === undefined) {
                            p = this.languages [this.sourceLang] [1] [tid]
                        }
                    }
                    return p
                })
                return result
            }
            return [this.val]
        }
    }

}
</script>

<style>

</style>